"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pandeMailTemplateReducer = exports.pandeMailTemplateActions = exports.TYPES = exports.LOADING_STATUS = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'pandeMailTemplate';

// アクションタイプ
const TYPES = exports.TYPES = {
  // メールテンプレート設定画面遷移
  GO_MAIN: PREFIX + 'Main',
  // 一覧ヘッダーを画面上部に残す
  CHANGE_SCROLL_TOP: PREFIX + 'ScrollTop',
  // メールテンプレート更新画面遷移
  GO_UPDATE: PREFIX + 'Update',
  // 入力値の保持
  SET_ENTRY: PREFIX + 'SetEntry',
  // ローディング画面表示／非表示
  SET_LOADING: PREFIX + 'SetLoading',
  // メールテンプレート更新結果画面遷移
  GO_CONFIRM: PREFIX + 'Confirm',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  UPDATE: 'update',
  CONFIRM: 'confirm'
};

// 読み込みステータス
const LOADING_STATUS = exports.LOADING_STATUS = {
  NOW_LOADING: '0',
  DATA_COMPLETED: '1',
  NO_DATA: '2'
};

// 初期状態
const INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  scrollTop: 0
};
const pandeMailTemplateActions = exports.pandeMailTemplateActions = (0, _reduxActions.createActions)({
  [TYPES.GO_MAIN]: function () {
    return {
      value: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      templateNo: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.GO_CONFIRM]: function () {
    return {
      templateNo: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_LOADING]: function () {
    return {
      loadingStatus: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.CLEAR);
const pandeMailTemplateReducer = exports.pandeMailTemplateReducer = (0, _reduxActions.handleActions)({
  [TYPES.GO_UPDATE]: (state, action) => {
    const {
      templateNo
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      templateNo,
      dispContent: CONTENTS.UPDATE,
      loadingStatus: LOADING_STATUS.NOW_LOADING
    });
  },
  [TYPES.GO_CONFIRM]: (state, action) => {
    const {
      templateNo
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      templateNo,
      dispContent: CONTENTS.CONFIRM,
      loadingStatus: LOADING_STATUS.NOW_LOADING
    });
  },
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.GO_MAIN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.MAIN,
      loadingStatus: LOADING_STATUS.NOW_LOADING
    });
  },
  [TYPES.SET_LOADING]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      loadingStatus: action.payload.loadingStatus
    });
  },
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);